import { mergeByProp } from '@shared/utils/mergeByProp.js';
import createPersistedReducer from '../lib/createPersistedReducer.js';

const initialState = {
  suggestions: [],
  suggestionsLoading: false,
  suggestionsNeedsFetch: false,
  docsLoading: {},
  appDoc: [],
  appDocNeedsFetch: []
};

const persistConfig = {
  key: 'aiReducer',
  whitelist: ['suggestions']
};

export default createPersistedReducer(
  initialState,
  {
    GET_PUB_SUB_MESSAGE_suggestionsLoading: (state) => ({
      ...state,
      suggestionsLoading: true
    }),

    GET_PUB_SUB_MESSAGE_suggestions: (state) => ({
      ...state,
      suggestionsNeedsFetch: true
    }),

    GET_AI_SUGGESTIONS_SUCCESS: (state, payload) => ({
      ...state,
      suggestions: payload?.data?.suggestions || []
    }),

    CLEAR_AI_SUGGESTIONS_NEEDS_FETCH: (state) => ({
      ...state,
      suggestionsNeedsFetch: false,
      suggestionsLoading: false
    }),

    REMOVE_AI_SUGGESTION: (state, payload) => ({
      ...state,
      suggestions: state.suggestions.filter((n) => n.id !== payload.id)
    }),

    UPDATE_AI_SUGGESTION_META: (state, payload) => ({
      ...state,
      suggestions: state.suggestions.map((n) => {
        if (n.id === payload.suggestionId) {
          return { ...n, meta: payload.meta, suggestion: { ...n?.suggestion, suggestedValue: n?.suggestion?.suggestedValue?.filter?.((m) => !payload.meta?.dismissedKeys?.includes(m?.key)) } };
        }
        return n;
      })
    }),

    UPDATE_AI_ACTION_SUGGESTION_META: (state, payload) => ({
      ...state,
      suggestions: state.suggestions.map((n) => {
        if (n.id === payload.suggestionId) {
          return {
            ...n,
            meta: payload.meta,
            suggestion: {
              ...n?.suggestion,
              suggestedValue: {
                suggestedActions: n?.suggestion?.suggestedValue?.suggestedActions?.filter?.((m) => !payload.meta?.dismissedActions?.includes(m?.suggestedActionName)),
                otherActions: n?.suggestion?.suggestedValue?.otherActions?.filter?.((m) => !payload.meta?.dismissedActions?.includes(m?.suggestedActionName))
              }
            }
          };
        }
        return n;
      })
    }),

    REMOVE_FROM_ARGUMENT_LIST_SUGGESTIONS: (state, payload) => ({
      ...state,
      suggestions: state.suggestions.map((n) => {
        if (!n?.path?.endsWith('suggestions.arguments') && !n?.path?.includes(`[id:${payload.actionId}]`)) {
          return n;
        }

        return {
          ...n,
          suggestion: {
            ...n?.suggestion,
            suggestedValue: n?.suggestion?.suggestedValue?.filter?.((m) => m?.key !== payload.key)
          }
        };
      })
    }),

    SET_DOCS_LOADING: (state, payload) => ({
      ...state,
      docsLoading: payload
    }),

    GET_PUB_SUB_MESSAGE_docsLoading: (state, payload) => ({
      ...state,
      docsLoading: { ...state.docsLoading, [payload.data.appId]: payload.data.value }
    }),

    GET_APP_DOC_META_SUCCESS: (state, payload) => ({
      ...state,
      appDoc: mergeByProp('id', state.appDoc, Array.isArray(payload.data) ? payload.data : [payload.data])
    }),

    GET_PUB_SUB_MESSAGE_SHOULD_FETCH_APP_DOC_META: (state, payload) => ({
      ...state,
      appDocNeedsFetch: [...state.appDocNeedsFetch, { ...payload.data }]
    }),

    CLEAR_APP_DOC_NEEDS_FETCH: (state) => ({
      ...state,
      appDocNeedsFetch: []
    })
  },
  persistConfig
);
